import React from 'react';
import { IPartyStageForUser, TUserId } from '../../PartyClientResponse';
import { useSubscription } from './VideoControlContext';

const FullscreenParticipantVideoPlayer = ({
  participantId,
  stage,
  isScreenshare,
}: {
  participantId: TUserId;
  stage: IPartyStageForUser;
  isScreenshare: boolean;
}) => {
  const participant = stage.participants[participantId];
  const { setVideoContainerRef } = useSubscription({
    shouldSubscribe: true,
    participant,
    subscribeToAudio: true,
    subscribeToVideo: true,
    options: { enableAudioLevel: false, isScreenshare },
  });

  return (
    <div
      className={`ot-video-container square`}
      style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0 }}
      ref={setVideoContainerRef}
    />
  );
};

export default FullscreenParticipantVideoPlayer;
